import { ITasksState } from './tasks-module/state/tasks.reducer'
import { IProjectsState, projectsReducer } from './projects-module/state/projects/projects.reducer'
import { IUsersState, usersReducer } from './users-module/state/users.reducer'
import { IOrganizationsState, organizationsReducer } from './organizations-module/state/organizations.reducer'
import { ISettingsState, settingsReducer } from './settings-module/state/settings.reducer'
import { INavigationState, navigationReducer } from './navigation-module/state/navigation.reducer'
import { lafReducer } from './shared/services/current-user/states/laf/laf.reducer'
import { ILAF } from './shared/data-types/laf.interface'
import {
  favoriteProjectsReducer,
  IFavoriteProjectsState,
} from '@app/projects-module/state/favorite-projects/favorite-projects.reducer'
import {
  IOrganizationRolesState,
  organizationsRolesReducer,
} from '@app/organization-roles-module/state/organization-roles.reducer'
import { IProjectRolesState, projectRolesReducer } from '@app/project-roles/state/project-roles.reducer'
import { ITeamsState, teamsReducer } from '@app/teams-module/state/teams.reducer'
import { IDepartmentsState, departmentsReducer } from './settings-module/state/departments/departments.reducer'

export const AppStateReducers = {
  laf: lafReducer,
  projects: projectsReducer,
  projectRoles: projectRolesReducer,
  users: usersReducer,
  organizations: organizationsReducer,
  organizationsRoles: organizationsRolesReducer,
  settings: settingsReducer,
  navigation: navigationReducer,
  favoriteProjects: favoriteProjectsReducer,
  teams: teamsReducer,
  departments: departmentsReducer,
}

export interface AppState {
  laf: ILAF
  tasks: ITasksState
  projects: IProjectsState
  projectRoles: IProjectRolesState
  users: IUsersState
  organizations: IOrganizationsState
  organizationsRoles: IOrganizationRolesState
  settings: ISettingsState
  navigation: INavigationState
  favoriteProjects: IFavoriteProjectsState
  teams: ITeamsState
  departments: IDepartmentsState
}
